import React, { useState } from "react";
import InspectorForm from "./InspectorForm";

function AddInspector({ onClose }) {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    name: "",
    phone_number: "",
    certificate: "",
    certificate_id: "",
    certification_expire_date: "",
    has_permission: "",
    address: "",
    company_name: "",
    company_license: "",
    company_license_expiry_date: "",
    company_address: "",
    company_phone: "",
    company_email: "",
  });
  return (
    <div>
      <InspectorForm initialValues={formData} onClose={onClose} />
    </div>
  );
}

export default AddInspector;
